import {
    RegisteredRouter,
    UseNavigateResult,
    RoutePaths,
    // here is the only place where we can load the tanstack useNavigate
    // eslint-disable-next-line no-restricted-imports
    useNavigate as useTanstackNavigate,
} from '@tanstack/react-router'

import { useExtractRootSearchParams } from './useExtractRootSearchParams'

export const useNavigate = <TDefaultFrom extends string = string>(defaultOptions?: {
    from?: RoutePaths<RegisteredRouter['routeTree']>
}): UseNavigateResult<TDefaultFrom> => {
    const tanstackNavigate = useTanstackNavigate(defaultOptions)
    const extractRootSearchParams = useExtractRootSearchParams()

    return (params) => {
        const { search } = params

        return tanstackNavigate(
            // @ts-expect-error this is right, not sure why TS is complaining
            {
                ...params,
                search: (previous) => {
                    const rootSearchParams = extractRootSearchParams(previous)

                    if (search) {
                        if (typeof search === 'function') {
                            return {
                                ...rootSearchParams,
                                ...search(previous),
                            }
                        }
                        if (typeof search === 'object') {
                            return {
                                ...rootSearchParams,
                                ...search,
                            }
                        }
                        if (typeof search === 'boolean') {
                            return previous
                        }
                    }

                    return rootSearchParams
                },
            }
        )
    }
}
